<div class="main-content">
  <div class="row">
    <!-- Header -->
    <div class="header-actions">
      <h4 class="card-title">Product List</h4>
      <div style="display: flex; gap: 8px; align-items: center;">
        <fh-refresh-button [refresh]="refreshData" />
        <button mat-raised-button color="primary" (click)="addProduct()">
          <mat-icon>add</mat-icon>
          Add Product
        </button>
      </div>
    </div>

    <!-- Success Message -->
    @if (success_msg()) {
      <div class="alert alert-green">
        <span>{{ success_msg() }}</span>
      </div>
    }

    <!-- Error Message -->
    @if (error_msg()) {
      <div class="alert alert-danger" role="alert">
        <span>{{ error_msg() }}</span>
      </div>
    }

    <!-- Filters — showResetButton=false: Reset button injected inline as 5th grid slot -->
    <fh-filter-bar [showResetButton]="false">
      <!-- Destination Country Filter (country the product is sold in) -->
      <fh-form-autocomplete
        [options]="countryOptions()"
        [label]="'Destination Country'"
        [placeholder]="'Select destination...'"
        [showCounts]="true"
        appearance="outline"
        [formControl]="countryFilterFormControl"
        (selectionChange)="onCountryChange($any($event))"
      />

      <!-- Vendor Country Filter (seller's origin country) -->
      <fh-form-autocomplete
        [options]="vendorCountryOptions()"
        [label]="'Vendor Country'"
        [placeholder]="'Select vendor country...'"
        appearance="outline"
        [formControl]="vendorCountryFilterFormControl"
        (selectionChange)="onVendorCountryChange($any($event))"
      />

      <!-- Merchant Filter -->
      <fh-form-autocomplete
        [options]="merchantOptions()"
        [label]="'Merchant'"
        [placeholder]="'Select merchant...'"
        [showCounts]="true"
        appearance="outline"
        [formControl]="merchantFilterFormControl"
        (selectionChange)="onMerchantChange($any($event))"
      />

      <!-- Category Filter -->
      <fh-form-autocomplete
        [options]="categoryOptions()"
        [label]="'Category'"
        [placeholder]="'Select category...'"
        [showCounts]="true"
        appearance="outline"
        [formControl]="categoryFilterFormControl"
        (selectionChange)="onCategoryChange($any($event))"
      />

      <!-- Subcategory Filter -->
      <fh-form-autocomplete
        [options]="subcategoryOptions()"
        [label]="'Subcategory'"
        [placeholder]="'Select subcategory...'"
        appearance="outline"
        [formControl]="subcategoryFilterFormControl"
        (selectionChange)="onSubcategoryChange($any($event))"
      />

      <!-- Subsubcategory Filter (the selected subcategory's types) -->
      <fh-form-autocomplete
        [options]="subsubcategoryOptions()"
        [label]="'Subsubcategory'"
        [placeholder]="'Select subsubcategory...'"
        appearance="outline"
        [formControl]="subsubcategoryFilterFormControl"
        (selectionChange)="onSubsubcategoryChange($any($event))"
      />

      <!-- Search Input -->
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search Products</mat-label>
        <input
          matInput
          [value]="searchText()"
          (input)="searchText.set($any($event.target).value)"
          (keyup.enter)="onSearchChange(searchText())"
          placeholder="Search by name, ID..."
        />
        <button
          matSuffix
          mat-icon-button
          (click)="onSearchChange(searchText())"
        >
          <mat-icon>search</mat-icon>
        </button>
        @if (searchText()) {
          <button
            matSuffix
            mat-icon-button
            (click)="searchText.set(''); onSearchChange('')"
            class="clear-search-button"
          >
            <mat-icon>clear</mat-icon>
          </button>
        }
      </mat-form-field>

      <!-- 5th grid slot: Reset button inline to the right of Search Products -->
      <div class="reset-inline">
        <button mat-stroked-button (click)="onResetFilters()" class="reset-btn">
          <mat-icon>refresh</mat-icon>
          Reset Filters
        </button>
      </div>
    </fh-filter-bar>

    <!-- Data Table -->
    <fh-data-table
      [config]="tableConfig()"
      [sortProp]="sortProp()"
      [sortDir]="sortDir()"
      [pageIndex]="pageIndex()"
      [pageSize]="pageSize()"
      [actions]="tableActions()"
      (sortChange)="onSortChange($event)"
      (pageChange)="onPageChange($event)"
    />
  </div>
</div>
